import { useState, useRef, useEffect } from 'react';
import { useSyncState } from 'shared/hooks/useSyncState';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/store';
import { setDrawerOpen, setHeaderTitle } from 'features/ui/model/uiSlice';
import { TableContentForMechanic } from 'entities/table/ui/TableContentForMechanic';
import { useGetPartnersQuery } from 'widgets/product/ui/api/getShopsApi';
import { useDeletePartnerMutation } from 'widgets/partner/api/getPartnerApi';
import { DrawerPartner } from 'widgets/partner/DrawerPartner';
import { Drawer, IconButton, Typography } from '@mui/material';
import { DrawerContent } from 'shared/ui/Drawer/DrawerStyles';
import { DrawerChangePartner } from 'widgets/partner/DrawerChangePartner';
import CloseIcon from '@mui/icons-material/Close';

const fields = [
  {
    field: 'partner_id',
    title: 'ID',
    width: '10%',
  },
  {
    field: 'title_kk',
    title: 'Наименование на казахском',
    width: '30%',
  },
  {
    field: 'title_ru',
    title: 'Наименование на русском',
    width: '30%',
  },
  {
    field: 'title_kg',
    title: 'Наименование на киргизском',
    width: '30%',
  },
  {
    field: 'title_uz',
    title: 'Наименование на узбекском',
    width: '30%',
  },
  {
    field: 'title_en',
    title: 'Наименование на английском',
    width: '30%',
  },
  {
    field: 'description_kk',
    title: 'Описание на казахском',
    width: '30%',
  },
  {
    field: 'description_ru',
    title: 'Описание на русском',
    width: '30%',
  },
  {
    field: 'description_kg',
    title: 'Описание на киргизском',
    width: '30%',
  },
  {
    field: 'description_uz',
    title: 'Описание на узбекском',
    width: '30%',
  },
  {
    field: 'description_en',
    title: 'Описание на английском',
    width: '30%',
  },
  {
    field: 'created_at',
    title: 'Дата создания',
    width: '30%',
  },
  {
    field: 'updated_at',
    title: 'Дата обновления',
    width: '30%',
  },
];

export const PartnerWidget = () => {
  const { isDrawerOpen } = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();
  const { app_type } = useParams();
  const [pagination, setPagination] = useState<{
    page: number;
    count: number;
    search: string;
  }>({
    page: 1,
    count: 10,
    search: '',
  });
  const [isShowSearch, setIsShowSearch] = useState(false);
  const searchQuery = useSyncState('');
  const searchRef = useRef('');

  const handleSetSearch = (search: string) => {
    searchQuery.set(search);
    searchRef.current = search;
  };

  const { data: partnersList, isSuccess } = useGetPartnersQuery({
    page: pagination.page,
    per_page: pagination.count,
    order: 1,
  });

  const partList = { item: [] as any };

  if (partnersList) {
    partnersList.forEach((item) => {
      partList.item.push({
        id: item.partner_id,
        partner_id: item.partner_id,
        title_kk: item.title_kk,
        title_ru: item.title_ru,
        title_kg: item.title_kg,
        title_uz: item.title_uz,
        title_en: item.title_en,
        description_kk: item.description_kk,
        description_ru: item.description_ru,
        description_kg: item.description_kg,
        description_uz: item.description_uz,
        description_en: item.description_en,
        photo_preview: item.photo_preview,
        created_at: item.created_at,
        updated_at: item.updated_at,
      });
    });
  }

  const handleClearSearch = () => {
    setIsShowSearch(false);
    searchQuery.set('');
    searchRef.current = '';
    setPagination((prev) => ({
      ...prev,
      search: '',
    }));
  };

  useEffect(() => {
    if (app_type) {
      dispatch(setHeaderTitle(app_type!.toUpperCase()));
    }
  }, [app_type]);

  const [deletePartner] = useDeletePartnerMutation();
  const handleDeletePartner = (id: number) => {
    deletePartner(id).then(() => {
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    });
  };

  const [titKz, setTitKz] = useState('');
  const [titRu, setTitRu] = useState('');
  const [titKg, setTitKg] = useState('');
  const [titUz, setTitUz] = useState('');
  const [titEn, setTitEn] = useState('');

  const [descKz, setDescKz] = useState('');
  const [descRu, setDescRu] = useState('');
  const [descKg, setDescKg] = useState('');
  const [descUz, setDescUz] = useState('');
  const [descEn, setDescEn] = useState('');

  const [partId, setPartId] = useState(0);

  const [drawerVariant, setDrawerVariant] = useState<{
    variant: 'create' | 'editPartner';
    title: string;
  }>({
    variant: 'create',
    title: 'Изменить данные',
  });

  const handleDrawerEdit = (id: number) => {
    setDrawerVariant({
      variant: 'editPartner',
      title: 'Измененить партнера',
    });
    dispatch(setDrawerOpen(true));

    partList.item.map((c: any) => {
      if (c.id === id) {
        setTitKz(c.title_kk);
        setTitRu(c.title_ru);
        setTitKg(c.title_kg);
        setTitUz(c.title_uz);
        setTitEn(c.title_en);

        setDescKz(c.description_kk);
        setDescRu(c.description_ru);
        setDescKg(c.description_kg);
        setDescUz(c.description_uz);
        setDescEn(c.description_en);

        setPartId(id);
      }
    });
  };

  const onDrawerClose = () => {
    dispatch(setDrawerOpen(false));
    setDrawerVariant({ variant: 'create', title: '' });
  };

  return (
    <>
      {isSuccess ? (
        <TableContentForMechanic
          title="Список партнера"
          fields={fields}
          list={{ list: partList.item }}
          count={partList.item.length}
          page={pagination.page - 1}
          perPage={pagination.count}
          onPageChange={(_, page) => {
            setPagination((prev) => ({
              ...prev,
              page: page + 1,
            }));
          }}
          onRowsPerPageChange={(e) => {
            setPagination(() => ({
              page: 1,
              count: parseInt(e.target.value),
              search: pagination.search,
            }));
          }}
          isShowSearch={isShowSearch}
          onShowSearch={(showSearch) => setIsShowSearch(showSearch)}
          onClearSearch={handleClearSearch}
          search={searchQuery.get()}
          setSearch={handleSetSearch}
          onRowClick={() => {}}
          onDeleteClick={handleDeletePartner}
          onChangeClick={handleDrawerEdit}
        />
      ) : (
        false
      )}
      <Drawer
        anchor="right"
        open={isDrawerOpen}
        onClose={onDrawerClose}
      >
        <DrawerContent>
          <div className="header">
            <Typography
              variant="h5"
              sx={{ fontWeight: '600' }}
            >
              {drawerVariant.title}
            </Typography>
            <IconButton
              onClick={onDrawerClose}
              sx={{ color: '#000' }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className="content">
            {drawerVariant.variant === 'create' && <DrawerPartner />}

            {drawerVariant.variant === 'editPartner' && (
              <DrawerChangePartner
                partnerId={partId}
                title_en={titEn}
                title_kg={titKg}
                title_kk={titKz}
                title_ru={titRu}
                title_uz={titUz}
                description_kk={descKz}
                description_ru={descRu}
                description_kg={descKg}
                description_en={descEn}
                description_uz={descUz}
                photo_preview="TO DO DONT KNOW WHAT IS THIS"
              />
            )}
          </div>
        </DrawerContent>
      </Drawer>
    </>
  );
};
